<template>
  <div class="v-statistical-wrap">
    <el-table :data="vData">
      <el-table-column label="想看" prop="n1"></el-table-column>
      <el-table-column label="观看" prop="n2"></el-table-column>
      <el-table-column label="回放" prop="n3"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" :aa="scope">编辑</el-button>
          <el-button size="mini" type="danger">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      vData: [{ n1: 222, n2: 333, n3: 4444 }]
    }
  }
}
</script>
<style lang="stylus" scoped>
.v-statistical-wrap{
    width:100%;
    max-width: 900px;
    margin: 30px auto;
}
</style>
